module.exports = __webpack_public_path__ + "media/images/ninestars/clients/client-6-27f73326e31be0639067ac723fc3300e.png";